import { useCallback, useMemo, useState } from 'react'
import {
  readFavoriteInventoryIds,
  toggleFavoriteInventoryId,
} from '@/lib/inventoryFavorites'

export function useInventoryFavorites() {
  const [version, setVersion] = useState(0)

  const ids = useMemo(() => readFavoriteInventoryIds(), [version])

  const isFavorite = useCallback((inventoryId: string) => ids.has(inventoryId), [ids])

  const toggle = useCallback((inventoryId: string) => {
    toggleFavoriteInventoryId(inventoryId)
    setVersion((v) => v + 1)
  }, [])

  return { isFavorite, toggle, favoriteIds: ids }
}
